import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { AppService } from "app/services/app/app.service";
import { RestService } from "app/services/rest/rest.service";
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from "@angular/material/table";
import { MatAccordion } from '@angular/material/expansion';
import { Log } from "app/core/logging/log";
import { Utils } from "app/components/utils/Utils";
import { debounceTime, distinctUntilChanged, filter, Subject } from "rxjs";

export interface User {
  username: string;
  name: string;
  roles: string;
}

@Component({
    selector: 'app-login-as',
    templateUrl: './login-as.component.html',
    styleUrls: ['./login-as.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoginAsComponent implements OnInit {

    @ViewChild(MatAccordion) accordion!: MatAccordion;
    isImpersonating = false;
    displayedColumns: string[] = ['username', 'actions'];
    dataSource = new MatTableDataSource<User>([]);
    inputFiltro$ = new Subject<string>();

    constructor(private appService: AppService, private restService: RestService, private snack: MatSnackBar) {
        this.isImpersonating = this.appService.isImpersonating();
    }

    ngOnInit() {
        // Aquí deberías cargar los usuarios desde tu API
        /*
        const users: User[] = [
            { username: 'donmass31@gmail.com', name: 'donmass31', roles: 'USER' },
            { username: 'lorenabarea8@gmail.com', name: 'lorenabarea8', roles: 'USER' },
            { username: 'admin', name: 'Admin Root', roles: 'ADMIN' }
        ];
        this.dataSource.data = users;
        */
       Log.debug('isAdmin', {isAdmin: this.appService.isAdmin()});
       this.inputFiltro$.pipe(
            debounceTime(300),         // Espera 300ms de silencio
            distinctUntilChanged(),    // Solo emite si el texto cambió respecto al anterior
            filter(texto => texto.trim().length >= 3)
        ).subscribe(filterValue => {this.searchUsers(filterValue);this.dataSource.filter = filterValue;
        });

    }
    
    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
       // this.dataSource.filter = filterValue;
       this.inputFiltro$.next(filterValue);
       Log.debug("applyFilter", {event});
    }

    loginAs(username: string) {
        this.restService.loginAs(username).subscribe((result) => {
            this.appService.saveOriginalToken();
            this.appService.showSuccessToast(this.appService.getTraduccion('common.welcome'));
            this.appService.setToken(result.token);
            this.snack.open(this.appService.getTraduccion('admin.users.started', { username }), this.appService.getTraduccion('common.close'), { duration: 3000 });
            setTimeout(()=> location.reload(), 1000);
        });
    }


    getProfile(){
        this.restService.getProfile().subscribe(result => {
            if(result.id !=null && result.id != 0){
                this.appService.usuario = result;
            }
        });
    }

    searchUsers(value:string|null){
        if(!this.appService.isAdmin()){
            return;
        }

        let filters: any[] = [];
        if(value != null){
            filters.push({
                field: 'email',
                operator: 'LIKE',
                value: value,
                values: []
            });
        }
        
        this.restService.searchUsers(Utils.generateFilters(filters)).subscribe(result => {
            this.dataSource.data = result.content;
        });
    }


    stop() {
        this.appService.restoreOriginalToken();
        this.snack.open(this.appService.getTraduccion('admin.users.stopped'), this.appService.getTraduccion('common.close'), { duration: 3000 });
        setTimeout(()=> location.reload(), 1000);
    }

    get impersonatedUser(): string | null {
        return this.appService.usuario.username;
    }
}
